/* Lunette — after "Add to cart", go to the cart page.
   The theme's cart is set to "page" (no drawer), and in that mode the theme only says "Added"
   and stays on the product page — the shopper never sees the cart, the free-shipping bar, the
   second-cup offer or the add-ons. This listens for the theme's own add event and opens /cart.
   Does nothing while a cart drawer exists (cart type switched back to drawer) or on the cart
   page itself, and never fires on a failed add. Installed from layout/theme.liquid. */
(function () {
  if (window.__lunCartRedirectBound) return;
  window.__lunCartRedirectBound = true;
  document.addEventListener('cart:update', function (e) {
    var data = e && e.detail && e.detail.data;
    if (!data || data.source !== 'product-form-component' || data.didError) return;
    if (document.querySelector('cart-drawer-component')) return;
    var path = window.location.pathname.replace(/\/$/, '');
    if (path.slice(-5) === '/cart') return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'cart';
  });
})();
